import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgIf } from '@angular/common';
import { VendorEditorComponent } from '../vendor-editor/vendor-editor.component';
import { Vendor } from 'app/models/entities/vendors/vendor';

export interface VendorEditorDialogResult
{
    success?: boolean;
    vendor?: Vendor;
}

@Component({
    selector: 'app-vendor-editor-dialog',
    templateUrl: './vendor-editor-dialog.component.html',
    standalone: true,
    imports: [
        NgIf,
        VendorEditorComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class VendorEditorDialogComponent
{
    @Input() open = false;
    @Input() vendorId: number = null;
    @Output() closed = new EventEmitter<VendorEditorDialogResult | null>();

    @ViewChild('vendorEditor') vendorEditor: VendorEditorComponent;
    isSaving = false;

    saveVendor() {
        this.vendorEditor.onSubmit();
    }

    close() {
        this.closed.emit(null);
    }

    closeSaved(vendor: Vendor) {
        this.closed.emit({success: true, vendor: vendor});
    }
}
